import { colors } from '@/constants';
import { BREAKPOINT } from '@/constants/enum';
import styled from 'styled-components';

interface Props {
  isOpenGuide: boolean;
}
export const BlockListStyled = styled.div<Props>`
  .blocklist-wrapper {
    display: ${(props) => (props.isOpenGuide ? 'block' : 'none')};
    position: fixed;
    width: 100vw;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #303030;
    opacity: 0.5;
    z-index: 501;
  }
  .add-rule-wrapper {
    z-index: 502;
    position: relative;
    .banner-template-right {
      padding: 0rem 1rem;
    }
  }
  @media screen and (max-width: ${BREAKPOINT.MD}px) {
    .add-rule-wrapper {
      .banner-template-right {
        padding: 0rem 1.5rem;
      }
    }
  }
  @media screen and (max-width: ${BREAKPOINT.SM}px) {
    .add-rule-wrapper {
      .banner-template-right {
        padding: 1rem;
      }
    }
  }
  .text-decoration {
    .Polaris-Text--bodySm {
      text-decoration: underline;
    }
    .Polaris-Badge--toneWarning {
      background-color: #ffea8a;
    }
  }

  .table-container {
    overflow: auto;
  }
  .disable {
    pointer-events: none;
    opacity: 0.5;
  }
  .btn-container {
    display: flex;
    align-items: center;
    position: relative;
    min-width: 90px;
    .absolute {
      position: absolute;
      top: 0;
      left: 2.25rem;
    }

    .control-btn {
      display: none;
      height: 20px;
    }
    .control-btn-toggle {
      display: block;
    }
    .remove-btn {
      &:hover {
        border-color: ${colors.critical};
        svg {
          fill: ${colors.critical};
        }
      }
    }
  }

  .Polaris-IndexTable__TableRow {
    &:hover {
      .control-btn {
        display: block;
      }
    }
  }

  .header {
    display: flex;
    background-color: #f1f1f1;
    padding: 1.25rem 1.5rem;
    border-radius: 0.25rem;
    .Polaris-Icon {
      margin: 0 0.5rem;
    }
  }
  .card-table {
    margin-top: 1rem;
    position: relative;
    .Polaris-IndexFilters-Container {
      padding-right: 2.75rem;
      padding-left: 0.25rem;
    }
    .btn-delete {
      position: absolute;
      top: 0.5rem;
      right: 1rem;
      z-index: 10;
      display: flex;
      gap: 0.5rem;
    }
  }
  .d-flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  nav {
    display: flex;
    justify-content: center;
  }
  .add-rule-container {
    background-color: white;
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 0.5rem;
    min-height: 115px;
    cursor: pointer;
    &:hover {
      background-color: ${colors.gray_background};
    }
  }
  .add-rule-img {
    margin-bottom: 0.5rem;
    max-width: 100%;
    height: 50px;
  }
  .add-rule-title {
    align-items: center;
    .Polaris-Icon {
      margin: 0;
    }
  }
  .Polaris-Filters-ConnectedFilterControl__AuxiliaryContainer {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
  }

  .selected-resource {
    .Polaris-IndexTable__TableHeading--first {
      background-color: #ffffff;
    }
  }
  @media screen and (max-width: 490px) {
    .Polaris-IndexTable__TableHeading--first .Polaris-Checkbox__Backdrop {
      display: block;
    }
  }

  .ml-8 {
    margin-left: 0.5rem;
  }
  .mr-8 {
    margin-right: 0.5rem;
  }
  .mr-4 {
    margin-right: 4px;
  }
  .mt-16 {
    margin-top: 1rem;
  }
  .pd-16 {
    padding: 0.5rem;
  }
  .pb-16 {
    padding-bottom: 1rem;
  }
  .div-disable {
    pointer-events: none;
    opacity: 0.5;
  }
`;
